import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import { auth } from '@/firebase'

import Toasted from 'vue-toasted'
Vue.use(Toasted, {
  action : {
    text : 'Close',
    onClick : (e, toastObject) => {
        toastObject.goAway(0);
    },
    class: 'text-white',
  },
  containerClass: 'top-0',
  duration: 3000,
  position: 'top-center'

})

import '@/assets/css/tailwind.css'


Vue.config.productionTip = false

let app = '';

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})


